{
  "localization.title": "Talen",
  "localization.count": "{count, plural, one {# taal} other {# talen}}",
  "localization.tabs_label": "Onderdelen van Talen",
  "localization.tab.coverage": "Dekking",
  "localization.tab.queue": "Te beoordelen",
  "localization.tab.propose": "Voorstellen",
  "localization.tab.glossary": "Woordenlijst",
  "localization.rtl": "RTL",
  "localization.test_output": "Testuitvoer (geen echte vertaling)",

  "localization.field.title": "Titel",
  "localization.field.description": "Beschrijving",
  "localization.field.meta_description": "Metabeschrijving",
  "localization.field.alt": "Alt-tekst",

  "localization.status.draft": "Concept",
  "localization.status.proposed": "Voorgesteld",
  "localization.status.in_review": "In review",
  "localization.status.approved": "Goedgekeurd",
  "localization.status.rejected": "Afgewezen",
  "localization.status.stale": "Verouderd",
  "localization.status.superseded": "Vervangen",
  "localization.status.missing": "Ontbreekt",

  "localization.origin.source": "Brontekst",
  "localization.origin.human": "Handmatig",
  "localization.origin.ai": "AI",
  "localization.origin.ai_via": "AI via {provider}",
  "localization.origin.tm": "Vertaalgeheugen",
  "localization.origin.import": "Import",
  "localization.origin.fixture": "Demotekst",

  "localization.mode.published": "Live",
  "localization.mode.preview": "Alleen preview",
  "localization.mode.off": "Uit",

  "localization.web.live": "Live",
  "localization.web.live_incomplete": "Live, {count, plural, one {# woning onvolledig} other {# woningen onvolledig}}",
  "localization.web.ready": "Klaar om te publiceren",
  "localization.web.preview": "Preview",
  "localization.web.off": "Uit",
  "localization.web.not_on_site": "Niet op de website",

  "localization.coverage.live_count": "{count, plural, =0 {Nog geen taal live} one {# taal live} other {# talen live}}",
  "localization.coverage.preview_count": "{count, plural, one {# in preview} other {# in preview}}",
  "localization.coverage.site_properties": "{count, plural, one {{n} woning op de website} other {{n} woningen op de website}}",
  "localization.coverage.table_label": "Taaldekking van {site}",
  "localization.coverage.col_locale": "Taal",
  "localization.coverage.col_website": "Website",
  "localization.coverage.col_coverage": "Goedgekeurd per tekst",
  "localization.coverage.col_reviewers": "Reviewer",
  "localization.coverage.bar_label": "{field}: {approved} van {total} goedgekeurd, {pending} in review, {stale} verouderd, {missing} ontbreekt",
  "localization.coverage.legend": "Betekenis van de kleuren",
  "localization.coverage.legend_approved": "Goedgekeurd",
  "localization.coverage.legend_pending": "In review",
  "localization.coverage.legend_stale": "Verouderd",
  "localization.coverage.legend_missing": "Ontbreekt",
  "localization.coverage.signal_pending": "{count, plural, one {# tekst wacht op review} other {# teksten wachten op review}}",
  "localization.coverage.signal_stale": "{count, plural, one {# tekst verouderd} other {# teksten verouderd}}",
  "localization.coverage.no_reviewer": "Geen reviewer",
  "localization.coverage.reviewers": "{first} en {count, plural, one {# ander} other {# anderen}}",
  "localization.coverage.publish": "Publiceren",
  "localization.coverage.other_title": "Talen buiten de website",
  "localization.coverage.other_hint": "Taalprofielen of vertalingen die nog niet aan een website hangen.",
  "localization.coverage.empty_title": "Nog geen talen",
  "localization.coverage.empty_body": "Voeg een taal toe aan de website om de dekking te zien.",

  "localization.detail.website": "Website",
  "localization.detail.readiness_loading": "Gereedheid wordt opgehaald.",
  "localization.detail.not_on_site": "Deze taal staat nog niet op een website.",
  "localization.detail.fields": "Teksten per veld",
  "localization.detail.n_approved": "{n} goedgekeurd",
  "localization.detail.n_pending": "{n} in review",
  "localization.detail.n_stale": "{n} verouderd",
  "localization.detail.n_missing": "{n} ontbreekt",
  "localization.detail.no_reviewer_body": "Zonder reviewer kan niemand teksten in deze taal goedkeuren. Een beheerder wijst die toe bij Instellingen, Team.",
  "localization.detail.publish_when_ready": "Publiceren kan zodra {count, plural, one {de woning een goedgekeurde titel en beschrijving heeft} other {alle {n} woningen een goedgekeurde titel en beschrijving hebben}}.",
  "localization.detail.gaps": "{count, plural, one {{n} woning mist tekst} other {{n} woningen missen tekst}}",
  "localization.detail.to_queue": "Naar de wachtrij",
  "localization.detail.other_title": "Nog niet op de website",
  "localization.detail.other_body": "Voeg deze taal toe bij Talen van de website om per woning te zien wat ontbreekt. Voorstellen maken kan al.",

  "localization.ready.meter": "Woningen compleet in {locale}",
  "localization.ready.meter_value": "{complete} van {total}",

  "localization.gaps.label": "Woningen met ontbrekende teksten",
  "localization.gaps.fields_label": "Open velden van {reference}",
  "localization.gaps.no_title": "Nog zonder titel",
  "localization.gaps.open": "Dossier",
  "localization.gaps.open_label": "Dossier {reference} openen bij de teksten",
  "localization.gaps.propose": "Voorstel maken",
  "localization.gaps.propose_label": "Voorstel maken voor {reference}",
  "localization.gaps.more": "{count, plural, =0 {Niet alle woningen staan hier.} one {En nog # woning.} other {En nog # woningen.}}",

  "localization.publish.title": "{locale} publiceren",
  "localization.publish.body": "Op {site}. Live na de volgende publicatie van de website.",
  "localization.publish.submit": "Publiceren",
  "localization.publish.to_queue": "Naar de wachtrij",
  "localization.publish.ready_title": "{count, plural, one {De woning op de website is compleet} other {Alle {n} woningen op de website zijn compleet}}",
  "localization.publish.ready_body": "Titel en beschrijving zijn in het {locale} goedgekeurd.",
  "localization.publish.not_ready": "{count, plural, one {{n} woning mist nog goedgekeurde tekst in het {locale}.} other {{n} woningen missen nog goedgekeurde tekst in het {locale}.}}",
  "localization.publish.not_on_site": "{locale} staat nog niet op deze website. Voeg de taal eerst toe bij Talen van de website.",
  "localization.publish.blocked_title": "Publiceren is geweigerd",
  "localization.publish.blocked_for": "{locale} kan niet live",
  "localization.publish.conflict_title": "Intussen gewijzigd",
  "localization.publish.conflict_body": "Iemand anders heeft de talen van deze website gewijzigd. Ververs en kijk of publiceren nog nodig is.",
  "localization.publish.conflict_refresh": "Verversen",
  "localization.publish.done": "{locale} staat klaar voor de website",
  "localization.publish.done_body": "Live na de volgende publicatie van de website.",

  "localization.sitelocales.open": "Talen van de website",
  "localization.sitelocales.title": "Talen van {site}",
  "localization.sitelocales.body": "Kies per taal of die live staat, alleen in preview of uit. De volgorde geldt voor het taalmenu.",
  "localization.sitelocales.list_label": "Talen en hun stand",
  "localization.sitelocales.new": "Nieuw op deze website",
  "localization.sitelocales.ready": "{count, plural, one {De woning is compleet} other {Alle woningen compleet}}",
  "localization.sitelocales.not_ready": "{count, plural, one {{n} woning mist tekst} other {{n} woningen missen tekst}}",
  "localization.sitelocales.mode_label": "Stand van {locale}",
  "localization.sitelocales.up": "{locale} omhoog",
  "localization.sitelocales.down": "{locale} omlaag",
  "localization.sitelocales.publish_rule": "Live zetten kan pas als alle websitewoningen in die taal een goedgekeurde titel en beschrijving hebben.",
  "localization.sitelocales.going_down_title": "Taal gaat van de website",
  "localization.sitelocales.going_down_body": "Na de volgende publicatie staat {locales} niet meer live.",
  "localization.sitelocales.add": "Taal toevoegen",
  "localization.sitelocales.add_placeholder": "Kies een taal",
  "localization.sitelocales.add_hint": "Een nieuwe taal start in preview.",
  "localization.sitelocales.save": "Talen opslaan",
  "localization.sitelocales.saved": "Talen opgeslagen",
  "localization.sitelocales.saved_body": "Zichtbaar na de volgende publicatie van de website.",
  "localization.sitelocales.conflict_body": "Iemand anders heeft de talen van deze website gewijzigd. Ververs om met de nieuwste stand verder te gaan; je wijzigingen hier vervallen.",

  "localization.queue.list_label": "Teksten in de wachtrij",
  "localization.queue.all_locales": "Alle talen",
  "localization.queue.my_locales": "Mijn talen",
  "localization.queue.locale": "Taal",
  "localization.queue.show": "Tonen",
  "localization.queue.status_review": "Te beoordelen",
  "localization.queue.status_stale": "Verouderd",
  "localization.queue.status_all": "Alles",
  "localization.queue.clear": "Filters wissen",
  "localization.queue.you_review": "Jij beoordeelt {locales}",
  "localization.queue.read_only_item": "Alleen bekijken: je bent geen reviewer voor deze taal",
  "localization.queue.no_review_title": "Alleen bekijken",
  "localization.queue.no_review_body": "Goedkeuren doet een taalreviewer van die taal. Je ziet hier wat er klaarstaat.",
  "localization.queue.no_locales_title": "Nog geen talen toegewezen",
  "localization.queue.no_locales_body": "Je hebt reviewrecht, maar nog geen talen. Een beheerder wijst die toe bij Instellingen, Team.",
  "localization.queue.empty_title": "Niets te beoordelen",
  "localization.queue.done_title": "Alles beoordeeld",
  "localization.queue.empty_body": "Nieuwe voorstellen verschijnen hier zodra iemand een vertaling indient of AI een voorstel maakt.",
  "localization.queue.empty_action": "Voorstel maken",
  "localization.queue.empty_filtered_title": "Niets gevonden",
  "localization.queue.empty_stale_title": "Geen verouderde teksten",
  "localization.queue.empty_filtered_body": "Kies een andere taal of status.",

  "localization.keys.browse": "bladeren",
  "localization.keys.approve": "goedkeuren",
  "localization.keys.reject": "afwijzen",
  "localization.keys.ctrl_enter": "Ctrl ↵",

  "localization.review.position": "{n} van {count}",
  "localization.review.position_more": "{n} van {count}+",
  "localization.review.revision": "Revisie {n}",
  "localization.review.by_seed": "Demodata",
  "localization.review.prev": "Vorige tekst",
  "localization.review.next": "Volgende tekst",
  "localization.review.source": "Bron",
  "localization.review.proposal": "Voorstel",
  "localization.review.translation": "Vertaling",
  "localization.review.marks_hint": "Getallen zijn gemarkeerd om ze met de bron te vergelijken. Rood is een kritieke afwijking, oranje een waarschuwing.",
  "localization.review.current_version": "Huidige goedgekeurde versie bekijken",
  "localization.review.checked_at": "Feitencontrole uitgevoerd op {when}.",
  "localization.review.test_body": "De testadapter vertaalt niet: hij zet alleen een testlabel voor de brontekst. Goedkeuren kan daarom niet; wijs af of stuur terug.",
  "localization.review.stale_title": "Verouderd",
  "localization.review.stale_source_hint": "Maak een nieuw voorstel op basis van de nieuwe bron.",
  "localization.review.stale_facts_hint": "Klopt de tekst nog met de nieuwe gegevens, dan kun je hem opnieuw goedkeuren.",
  "localization.review.new_proposal": "Nieuw voorstel maken",
  "localization.review.decision": "Besluit",
  "localization.review.approve": "Goedkeuren",
  "localization.review.reapprove": "Opnieuw goedkeuren",
  "localization.review.approve_confirms": "Goedkeuren bevestigt dat je bron en voorstel volledig hebt gelezen.",
  "localization.review.reject": "Afwijzen",
  "localization.review.request_changes": "Terugsturen",
  "localization.review.reject_hint": "Het voorstel vervalt. Maak een nieuw voorstel.",
  "localization.review.request_hint": "Het voorstel gaat terug als concept, met jouw reden.",
  "localization.review.reject_submit": "Afwijzen",
  "localization.review.request_submit": "Terugsturen",
  "localization.review.reasons": "Veelgebruikte redenen",
  "localization.review.reason_facts": "Feiten kloppen niet met de woning.",
  "localization.review.reason_tone": "Toon of stijl past niet bij de website.",
  "localization.review.reason_incomplete": "Vertaling is onvolledig.",
  "localization.review.reason_test": "Testuitvoer, geen echte vertaling.",
  "localization.review.note": "Reden",
  "localization.review.note_hint": "Wordt bewaard bij deze versie en is zichtbaar voor wie het voorstel maakte.",
  "localization.review.note_required": "Geef een reden op.",
  "localization.review.cannot_approve": "Goedkeuren kan niet",
  "localization.review.cannot_decide": "Beoordelen kan niet",
  "localization.review.blocked_test": "Testuitvoer kan niet worden goedgekeurd.",
  "localization.review.blocked_qa": "De feitencontrole vond een kritieke afwijking.",
  "localization.review.blocked_source": "De brontekst is gewijzigd; maak eerst een nieuw voorstel.",
  "localization.review.not_allowed_title": "Je kunt {locale} niet goedkeuren.",
  "localization.review.not_allowed_locale": "Je beoordeelt alleen {locales}.",
  "localization.review.not_allowed_none": "Er zijn nog geen talen aan je toegewezen.",
  "localization.review.not_allowed_role": "Je rol {role} heeft geen reviewrecht.",
  "localization.review.reviewers": "Reviewers voor deze taal: {names}.",
  "localization.review.no_reviewers": "Deze taal heeft nog geen reviewer; een beheerder wijst die toe bij Instellingen, Team.",
  "localization.review.not_reviewable": "Status: {status}. Deze versie kan niet meer beoordeeld worden.",
  "localization.review.conflict_title": "Al beoordeeld of vervangen",
  "localization.review.conflict_body": "Iemand anders was je voor, of er is een nieuwer voorstel. De wachtrij is ververst.",
  "localization.review.done_approve": "Goedgekeurd",
  "localization.review.done_reject": "Afgewezen",
  "localization.review.done_request_changes": "Teruggestuurd",
  "localization.review.failed_approve": "Goedkeuren is niet gelukt",
  "localization.review.failed_reject": "Afwijzen is niet gelukt",
  "localization.review.failed_request_changes": "Terugsturen is niet gelukt",

  "localization.qa.title": "Feitencontrole",
  "localization.qa.unchecked": "Niet gecontroleerd",
  "localization.qa.unchecked_body": "Voor deze versie is geen feitencontrole bewaard.",
  "localization.qa.ok": "Feiten kloppen",
  "localization.qa.ok_body": "Getallen, oppervlaktes, prijzen en referenties komen overeen met de woninggegevens. Uitgeschreven getallen herkent de controle niet; die controleer je zelf.",
  "localization.qa.critical": "{count, plural, one {# kritieke afwijking} other {# kritieke afwijkingen}}",
  "localization.qa.warnings": "{count, plural, one {# waarschuwing} other {# waarschuwingen}}",
  "localization.qa.severity_critical": "Kritiek:",
  "localization.qa.severity_warning": "Let op:",
  "localization.qa.found": "Gevonden: {value}.",
  "localization.qa.expected": "Verwacht: {value}.",
  "localization.qa.unknown_value": "onbekend",
  "localization.qa.forbidden_term": "verboden term uit de woordenlijst: {term}.",
  "localization.qa.numbers_found": "Getallen in de tekst:",
  "localization.qa.issue.fact_bedrooms_mismatch": "aantal slaapkamers wijkt af.",
  "localization.qa.issue.fact_bathrooms_mismatch": "aantal badkamers wijkt af.",
  "localization.qa.issue.fact_area_mismatch": "oppervlakte staat niet in de woninggegevens.",
  "localization.qa.issue.fact_year_mismatch": "bouwjaar wijkt af.",
  "localization.qa.issue.fact_unknown_number": "getal dat niet in de woninggegevens staat.",
  "localization.qa.issue.fact_price_in_text": "prijs in de tekst. Prijzen horen in de gegevens, niet in vrije tekst.",
  "localization.qa.issue.fact_reference_mismatch": "andere referentie dan deze woning.",
  "localization.qa.issue.text_html_not_allowed": "HTML in de tekst is niet toegestaan.",
  "localization.qa.issue.text_placeholder_mismatch": "plaatshouders verschillen van de bron.",
  "localization.qa.issue.text_empty": "de tekst is leeg.",

  "localization.fact.kind": "soort woning",
  "localization.fact.bedrooms": "slaapkamers",
  "localization.fact.bathrooms": "badkamers",
  "localization.fact.builtM2": "bebouwde oppervlakte",
  "localization.fact.usableM2": "bruikbare oppervlakte",
  "localization.fact.plotM2": "perceel",
  "localization.fact.terraceM2": "terras",
  "localization.fact.yearBuilt": "bouwjaar",
  "localization.fact.locality": "plaats",
  "localization.fact.municipality": "gemeente",
  "localization.fact.views": "uitzicht",
  "localization.fact.features": "voorzieningen",
  "localization.fact.energyRating": "energielabel",
  "localization.fact.touristLicense": "toeristenvergunning",
  "localization.fact.floorLevel": "verdieping",
  "localization.fact.price": "prijs",

  "localization.stale.source_changed": "De brontekst is gewijzigd.",
  "localization.stale.facts_changed": "Woninggegevens gewijzigd: {facts}.",
  "localization.stale.unknown": "Reden onbekend.",

  "localization.propose.property": "Woning",
  "localization.propose.property_placeholder": "Zoek op referentie of titel",
  "localization.propose.no_title": "Nog zonder titel",
  "localization.propose.field": "Tekst",
  "localization.propose.target": "Doeltaal",
  "localization.propose.target_placeholder": "Kies een taal",
  "localization.propose.start_title": "Kies een woning",
  "localization.propose.start_body": "Kies daarna de tekst en de doeltaal. De bron staat naast je voorstel.",
  "localization.propose.no_unit_title": "Geen brontekst",
  "localization.propose.no_unit_body": "Deze woning heeft nog geen brontekst voor {field}. Schrijf die eerst in de woning.",
  "localization.propose.facts_hint": "Neem getallen, prijzen en oppervlaktes ongewijzigd over. De feitencontrole vergelijkt ze met de woninggegevens.",
  "localization.propose.pick_target": "Kies een doeltaal om te beginnen.",
  "localization.propose.current": "Nu:",
  "localization.propose.no_current": "Nog geen versie in deze taal",
  "localization.propose.current_is_test": "De huidige versie is testuitvoer van de AI-testadapter. Schrijf hier de echte vertaling.",
  "localization.propose.replaces_review": "Een nieuw voorstel vervangt het voorstel dat nu in review staat.",
  "localization.propose.keeps_approved": "De goedgekeurde tekst blijft live tot je nieuwe voorstel is goedgekeurd.",
  "localization.propose.text_label": "Vertaling in {locale}",
  "localization.propose.count": "{count, plural, one {# teken} other {# tekens}}",
  "localization.propose.count_title": "{count, plural, one {# teken} other {# tekens}}, richtlijn voor titels is 120",
  "localization.propose.submit": "Voorstel indienen",
  "localization.propose.ai": "AI-voorstel aanvragen",
  "localization.propose.ai_test": "Testvoorstel aanvragen",
  "localization.propose.ai_tip": "Het resultaat komt als voorstel in de wachtrij. Er wordt niets gepubliceerd.",
  "localization.propose.ai_test_tip": "De testadapter maakt testuitvoer om de keten te proberen, geen vertaling.",
  "localization.propose.ai_test_hint": "Lokaal draait de testadapter: die vertaalt niet en maakt alleen testuitvoer.",
  "localization.propose.ai_hint": "Via {provider}. Het resultaat komt als voorstel in de wachtrij.",
  "localization.propose.ai_off": "AI staat uit.",
  "localization.propose.ai_budget_reached": "Het AI-budget van deze maand is op.",
  "localization.propose.budget": "Budget deze maand: {spent} van {limit}.",
  "localization.propose.no_ai_right": "AI-voorstellen vragen het recht om AI te gebruiken.",
  "localization.propose.test_adapter": "de testadapter",
  "localization.propose.base_mismatch_title": "Andere basisversie",
  "localization.propose.base_mismatch_reload": "Huidige versie laden",
  "localization.propose.sent": "Voorstel ingediend",
  "localization.propose.sent_ok": "Feitencontrole: geen kritieke afwijkingen.",
  "localization.propose.sent_critical": "Feitencontrole: kritieke afwijking gevonden.",
  "localization.propose.result_title": "Voorstel staat in de wachtrij",
  "localization.propose.result_body": "Een reviewer voor {locale} beoordeelt het. Er is niets gepubliceerd.",
  "localization.propose.result_critical_title": "Voorstel ingediend, maar geblokkeerd",
  "localization.propose.result_critical_body": "De feitencontrole vond een kritieke afwijking. Een reviewer kan dit niet goedkeuren; pas de tekst aan en dien opnieuw in.",
  "localization.propose.ai_tm_title": "Hergebruikt uit het vertaalgeheugen",
  "localization.propose.ai_tm_body": "Er bestond al een goedgekeurde vertaling van exact deze brontekst. Die staat nu als voorstel in de wachtrij voor {locale}.",
  "localization.propose.ai_test_title": "Testuitvoer (geen echte vertaling)",
  "localization.propose.ai_test_body": "De testadapter zette een testlabel voor de bron. Het staat in de wachtrij zodat je de keten kunt testen; goedkeuren kan niet.",
  "localization.propose.ai_title": "AI-voorstel in de wachtrij",
  "localization.propose.ai_body": "{provider} maakte een voorstel voor {locale}. Een reviewer beoordeelt het; er is niets gepubliceerd.",
  "localization.propose.ai_critical": "De feitencontrole vond een kritieke afwijking.",
  "localization.propose.ai_tm_toast": "Vertaling hergebruikt",
  "localization.propose.ai_test_toast": "Testuitvoer gemaakt (geen echte vertaling)",
  "localization.propose.ai_toast": "AI-voorstel gemaakt",
  "localization.propose.ai_toast_body": "Staat als voorstel in de wachtrij.",
  "localization.propose.to_queue": "Naar de wachtrij",
  "localization.propose.conflict_title": "Intussen is er een nieuwere versie",
  "localization.propose.conflict_body": "Sinds je begon is er een andere versie in deze taal gekomen. Kies welke tekst verder gaat.",
  "localization.propose.conflict_latest": "Nieuwste versie",
  "localization.propose.conflict_mine": "Jouw tekst",
  "localization.propose.conflict_unsent": "Niet ingediend",
  "localization.propose.conflict_load": "Nieuwste versie laden",
  "localization.propose.conflict_submit": "Mijn tekst indienen",
  "localization.propose.conflict_removed": "De versie waar je mee begon bestaat niet meer.",
  "localization.propose.matrix_title": "Alle talen van {reference}",
  "localization.propose.matrix_field": "Tekst",
  "localization.propose.matrix_pick": "{field} in {locale}: {status}. Openen",
  "localization.propose.no_rights_title": "Geen rechten voor voorstellen",
  "localization.propose.no_rights_body": "Vraag een beheerder om het recht om vertalingen voor te stellen.",

  "localization.glossary.add": "Term toevoegen",
  "localization.glossary.add_title": "Term toevoegen",
  "localization.glossary.edit_title": "Term wijzigen",
  "localization.glossary.edit_label": "{term} wijzigen",
  "localization.glossary.all_locales": "Alle talen",
  "localization.glossary.any_use": "Alles",
  "localization.glossary.locale": "Taal",
  "localization.glossary.locale_placeholder": "Kies een taal",
  "localization.glossary.search": "Woordenlijst doorzoeken",
  "localization.glossary.search_placeholder": "Begrip, term of notitie",
  "localization.glossary.col_locale": "Taal",
  "localization.glossary.col_term": "Term",
  "localization.glossary.col_status": "Gebruik",
  "localization.glossary.col_note": "Notitie",
  "localization.glossary.status": "Gebruik",
  "localization.glossary.status_preferred": "Voorkeur",
  "localization.glossary.status_allowed": "Toegestaan",
  "localization.glossary.status_forbidden": "Verboden",
  "localization.glossary.status_preferred_hint": "Gebruik deze term. Gaat mee in AI-opdrachten.",
  "localization.glossary.status_allowed_hint": "Mag, zonder voorkeur.",
  "localization.glossary.status_forbidden_hint": "Blokkeert goedkeuring als de term in een tekst staat.",
  "localization.glossary.concept": "Begrip",
  "localization.glossary.concept_hint": "Kleine letters, cijfers, punt en underscore, bijvoorbeeld kind.finca.",
  "localization.glossary.concept_invalid": "Gebruik alleen kleine letters, cijfers, punt en underscore.",
  "localization.glossary.term": "Term",
  "localization.glossary.note": "Notitie",
  "localization.glossary.dialog_body": "Geldt voor deze organisatie. Nieuwe voorstellen worden met de bijgewerkte lijst gecontroleerd.",
  "localization.glossary.read_only": "Termen beheert een taalreviewer.",
  "localization.glossary.added": "{term} toegevoegd",
  "localization.glossary.updated": "{term} bijgewerkt",
  "localization.glossary.deleted": "{term} verwijderd",
  "localization.glossary.delete_title": "{term} verwijderen?",
  "localization.glossary.delete_body": "Nieuwe voorstellen worden zonder deze term gecontroleerd. Bestaande vertalingen veranderen niet.",
  "localization.glossary.delete_confirm": "Term verwijderen",
  "localization.glossary.empty_title": "Nog geen termen",
  "localization.glossary.empty_body": "Leg vaste vertalingen vast, bijvoorbeeld dat finca geen boerderij wordt.",
  "localization.glossary.empty_filtered_title": "Geen termen gevonden",
  "localization.glossary.empty_filtered_body": "Kies een andere taal of zoekterm."
}
